// extracted by mini-css-extract-plugin
export default {"tasks":"DH-z","task":"EH-z","svg":"FH-z","text":"GH-z"};